import {
  getTableViewByType
} from './table-view';

export function FactInfoComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      filter: '<',
      fact: '<',
      openImage: '<',
      mode: '<',
    },
    controller: function($scope, $element, $sce) {
      $scope.trustAsHtml = $sce.trustAsHtml;
    },
    link: function(scope, element, attrs) {
      scope.$watch('fact', update);
      scope.$watch('filter', update);

      function update() {
        if (!scope.filter || !scope.fact) return;
        const newVal = scope.fact;
        const fact = newVal ? newVal : {};
        const mode = scope.mode || 'extended';
        scope.textData = fact ? fact['text_data'] : '';
        scope.event_id = fact ? fact['id'] : 0;
        const viewMode = getTableViewByType(fact['agent_eventtype.id']);
        const widget = viewMode.important.map(colView => {
          const data = colView.parse(fact, mode);
          const label = (mode === 'extended' &&
              fact['agent_eventtype.name'] !== 'DesktopVideo' &&
              data && colView.label) ?
            '<span class="label">' + colView.label + ':</span> ' : '';
          return label + data + ((label + data) ? '<br/>' : '');
        }).join('', '');
        element.html(widget);
        $compile(element.contents())(scope);
      }
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-info.component.js